// extracted by mini-css-extract-plugin
export default {"docs":"Docs_docs__YJQwr","main":"Docs_main__GYN8R"};